import { DepositIcon, ExchangeIcon, MMButton, PageActions, PayoutIcon, WithdrawIcon } from '@components'
import cn from '@integrations/classnames'
import { useNavigate } from '@integrations/routing'
import { paths, useMerchantAccounts, useMyAccountAccessQry } from 'mmfintech-backend-api'
import { isValidArray, tr } from 'mmfintech-commons'

function QuickActionsBar() {
  const { hasAnyWritePermission } = useMyAccountAccessQry()
  const { accounts } = useMerchantAccounts()
  const navigate = useNavigate()

  if (!hasAnyWritePermission) return null

  return (
    <PageActions className={cn('quick-actions-bar')}>
      <MMButton
        variant='primary'
        leftIcon={DepositIcon}
        caption={tr('FRONTEND.DASHBOARD.BUTTON_DEPOSIT', 'Deposit')}
        onClick={() => navigate(paths.banking.deposit())}
        data-test='button-deposit'
      />
      {isValidArray(accounts) && (
        <MMButton
          variant='dashboard'
          leftIcon={WithdrawIcon}
          caption={tr('FRONTEND.DASHBOARD.BUTTON_WITHDRAW', 'Withdraw')}
          onClick={() => navigate(paths.withdraw.select())}
          data-test='button-withdraw'
        />
      )}
      <MMButton
        variant='dashboard'
        leftIcon={ExchangeIcon}
        caption={tr('FRONTEND.DASHBOARD.BUTTON_EXCHANGE', 'Exchange')}
        onClick={() => navigate(paths.banking.exchange())}
        data-test='button-exchange'
      />
      {isValidArray(accounts) && (
        <MMButton
          variant='dashboard'
          leftIcon={PayoutIcon}
          caption={tr('FRONTEND.DASHBOARD.BUTTON_PAYOUT', 'Payout')}
          onClick={() => navigate(paths.payout.select())}
          data-test='button-payout'
        />
      )}
    </PageActions>
  )
}

export default QuickActionsBar
